import { Observable } from 'rxjs';
import { PushMessage } from 'src/services/PushMessageHandler';

import { Context } from '../aggregates';
import { LocationInfo } from '../cordovaPlugins/Location';
import {
  Permissions,
  permissions,
  permissions$,
} from '../cordovaPlugins/Permissions';
import { FluxType } from '../flux/buildFlux';
import { AuthState } from '../model/AuthenticationInfo';

/**
 * The services are not allowed to directly talk to react.
 * services can be expose observables which the UI can use.
 * Services cannot call for permissions (ios or android) themselves,
 * they must listen to the permissions$ and only start when possible.
 * @param flux
 */
export interface AppServices {
  location$: Observable<LocationInfo>;
  locationFunctions: {
    getLocation: () => Promise<LocationInfo>;
  };
  pushEvents$: Observable<PushMessage>;
  permissions$: Observable<Permissions>;
  permissionFunctions: {
    startPush: () => void;
    requestLocationBackgroundPermission: () => Promise<boolean>;
    requestLocationInUsePermission: () => Promise<boolean>;
    requestHighAccuracyLocationPermission: () => Promise<boolean>;
    askForLocationPermissionsAfterDenial(): Promise<boolean>;
  };
  keyboard: {
    resetKeyboard: () => void;
    useLongFormKeyboard: () => void;
    useSimpleKeyboard: () => void;
  };
}

export type Service<T> = (props: ServiceProps, extra?: any) => T;

export interface ServiceProps {
  authState$: Observable<AuthState>;
  permissions$: Observable<Permissions>;
  flux: FluxType; // deprecated ...
  updatePermissions: () => void;
}

export abstract class WlService {
  protected permissions$: Observable<Permissions> = permissions$;

  protected location$: Observable<LocationInfo>;

  protected props: ServiceProps;

  readonly services: AppServices;

  constructor(
    protected authState$: Observable<AuthState>,
    protected flux: FluxType,
    protected aggregates$: Observable<Context>,
  ) {
    this.props = {
      flux,
      authState$,
      permissions$: this.permissions$,
      updatePermissions: this.updatePermissions,
    };
  }

  protected updatePermissions() {
    // retrieve permissions
    permissions();
  }

  protected start<T>(name: string, service: Service<T>, extraParams?: any) {
    try {
      console.log(`Service.${name} starting`);
      return service(this.props, extraParams);
    } catch (e) {
      console.error(`Service.${name}`, e);
      return null;
    }
  }
}
